module.exports = __webpack_public_path__ + "img/notify1.7d63f4ac.png";